import React, { useEffect, useState, useMemo } from 'react';
/* global axios */
import api from '../services/apiService';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';  // Import von React Helmet
import Select from 'react-select'; // Neu: react-select importieren

const CreditNoteList = () => {
  const [creditNotes, setCreditNotes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();


  const [filters, setFilters] = useState(() => {
    const storedFilters = localStorage.getItem('creditNoteListFilters');
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
          creditNoteNumber: null,
          customer: null,
          contact: null,
          date: null,
          status: null,
        };
  });
  
  useEffect(() => {
    localStorage.setItem('creditNoteListFilters', JSON.stringify(filters));
  }, [filters]);
  
  const [serverFilterOptions, setServerFilterOptions] = useState({
    creditNoteNumbers: [],
    customers: [],
    contacts: [],
    dates: [],
    statuses: [],
  });

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const response = await api.get('/creditnotes/filter-options');
        setServerFilterOptions(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Filteroptionen:', error);
      }
    };
    fetchFilterOptions();
  }, []);

 // Pagination-Zustände:
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const limit = 25;

const buildQuery = () => {
  const params = new URLSearchParams();
  params.append('limit', limit);
  params.append('page', currentPage);
  if (filters.creditNoteNumber) {
    params.append('creditNoteNumber', filters.creditNoteNumber.value);
  }
  if (filters.referenceNumber) {
    params.append('referenceNumber', filters.referenceNumber.value);
  }
  if (filters.customer) {
    params.append('customer', filters.customer.value);
  }
  if (filters.contact) {
    params.append('contact', filters.contact.value);
  }
  if (filters.date) {
    params.append('date', filters.date.value);
  }
  if (filters.status) {
    params.append('status', filters.status.value);
  }
  return params.toString() ? `?${params.toString()}` : '';
};

useEffect(() => {
  const fetchCreditNotes = async () => {
    try {
      // Hier wird angenommen, dass buildQuery() den Query-String basierend auf den Filter- und Pagination-States erzeugt
      const query = buildQuery();
      const creditNotesResponse = await api.get(`/creditnotes/list${query}`);
      // Angenommen, der Response hat die Struktur { total, page, pages, data: [...] }
      setCreditNotes(creditNotesResponse.data.data);
    } catch (error) {
      console.error("Fehler beim Laden der Gutschriften:", error);
    }
  };

  fetchCreditNotes();
}, [filters, currentPage]);

 
  

  // Hilfsfunktion zum Formatieren von Datumsangaben
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind 0-indexiert
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  

  // Kunden laden, falls diese nicht in der Gutschrift enthalten sind
  const fetchCustomers = async () => {
    try {
      const response = await api.get("/customers");
      setCustomers(response.data);
    } catch (error) {
      console.error("Fehler beim Laden der Kunden:", error);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  // Hilfsfunktion: Finde den Kundennamen anhand der customerId
  const getCustomerName = (creditNote) => {
    if (creditNote.customer) {
      return creditNote.customer.company;
    }
    const found = customers.find((c) => c.id === creditNote.customerId);
    return found ? found.company : "Unbekannt";
  };

  

  // Gutschrift löschen
  const deleteCreditNote = (id) => {
    if (window.confirm('Möchten Sie diese Gutschrift wirklich löschen?')) {
      api.delete(`/creditnotes/${id}`)
        .then(() => {
          setCreditNotes((prev) => prev.filter((cn) => cn.creditNoteId !== id));
          alert('Gutschrift erfolgreich gelöscht!');
        })
        .catch((error) => console.error('Fehler beim Löschen der Gutschrift:', error));
    }
  };

  // PDF-Ansicht öffnen
  const handleViewPDF = (creditNoteId) => {
    const pdfUrl = `${api.defaults.baseURL}/documents/creditnote/${creditNoteId}/pdf`;
    window.open(pdfUrl, '_blank');
  };

    // Funktion zum Versenden der Gutschrift per E-Mail
    const handleMail = async (creditNoteId) => {
      try {
        await api.post(`/documents/creditnote/${creditNoteId}/mail`);
        alert('✅ Gutschrift erfolgreich gemailt!');
      } catch (error) {
        console.error('Fehler beim Mailen der Gutschrift:', error);
        alert('Fehler beim Mailen der Gutschrift!');
      }
    };

  return (
    <div className="creditnote-list">
      <Helmet>
        <title>Gutschriftliste</title>
        <meta name="description" content="Gutschriftliste" />
      </Helmet>
      <h1>Gutschriften</h1>

      {/* Filterzeile oberhalb der Tabelle */}
<div style={{ marginBottom: '20px' }}>
  <h3>Filter</h3>
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px' }}>
  <Select
  options={
    [...serverFilterOptions.creditNoteNumbers]
      .sort((a, b) => b.localeCompare(a, undefined, { numeric: true }))
      .map(val => ({ value: val, label: val }))
  }
  placeholder="Gutschrift Nummer"
  isClearable
  value={filters.creditNoteNumber}
  onChange={(selected) => setFilters({ ...filters, creditNoteNumber: selected })}
  styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
/>

    <Select
      options={serverFilterOptions.customers.map(val => ({ value: val, label: val }))}
      placeholder="Kunde"
      isClearable
      value={filters.customer}
      onChange={(selected) => setFilters({ ...filters, customer: selected })}
      styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
    />
    <Select
      options={serverFilterOptions.contacts.map(val => ({ value: val, label: val }))}
      placeholder="Besteller"
      isClearable
      value={filters.contact}
      onChange={(selected) => setFilters({ ...filters, contact: selected })}
      styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
    />
    <Select
      options={serverFilterOptions.dates.map(val => ({ value: val, label: val }))}
      placeholder="Datum"
      isClearable
      value={filters.date}
      onChange={(selected) => setFilters({ ...filters, date: selected })}
      styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
    />
    <Select
      options={serverFilterOptions.statuses.map(val => ({ value: val, label: val }))}
      placeholder="Status"
      isClearable
      value={filters.status}
      onChange={(selected) => setFilters({ ...filters, status: selected })}
      styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
    />
  </div>
</div>

      {creditNotes.length > 0 ? (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Gutschrift Nummer</th>
              <th>Kunde</th>
              <th>Besteller</th>
              <th>Datum</th>
              <th>Status</th>
              <th>Gesamt netto (€)</th>
              <th>Aktionen</th>
              <th>Ausgabe</th>
            </tr>
          </thead>
          <tbody>
          {creditNotes.map((creditNote) => (
              <tr key={creditNote.creditNoteId}>
                <td>{creditNote.creditNoteId}</td>
                <td>{creditNote.creditNoteNumber || '-'}</td>
                <td>{getCustomerName(creditNote)}</td>
                <td>
                  {creditNote.contact
                    ? `${creditNote.contact.contactFirstName} ${creditNote.contact.contactLastName}`
                    : 'Kein Besteller'}
                </td>
                <td>{formatDate(creditNote.date)}</td>
                <td>{creditNote.status}</td>
                <td>{(creditNote.totalNet?.toFixed(2).replace('.', ',') || '0,00') + ' €'}</td>
                <td>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                    <button
                      onClick={() => deleteCreditNote(creditNote.creditNoteId)}
                      style={{
                        fontSize: '15px',
                        padding: '5px 10px',
                        background: '#dc3545',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      Löschen
                    </button>
                  </div>
                </td>
                <td>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  <button
                    onClick={() => handleViewPDF(creditNote.creditNoteId)}
                    style={{
                      fontSize: '15px',
                      padding: '5px 10px',
                      background: '#28a745',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    Ansicht
                  </button>
                  <button
                      onClick={() => handleMail(creditNote.creditNoteId)}
                      style={{
                        fontSize: '15px',
                        padding: '5px 10px',
                        background: '#17a2b8',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      Mailen
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Keine Gutschriften verfügbar.</p>
      )}
      <div style={{ marginTop: '1rem' }}>
  <button
    onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
    disabled={currentPage === 1}
    style={{
      fontSize: '15px',
      padding: '8px 12px',
      backgroundColor:'rgb(155, 155, 155)',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    }} 
  >
    Vorherige
  </button>
  <span style={{ margin: '0 1rem' }}>
    Seite {currentPage} von {totalPages}
  </span>
  <button
    onClick={() => setCurrentPage(currentPage + 1)}
    disabled={currentPage >= totalPages}
    style={{
      fontSize: '15px',
      padding: '8px 12px',
      backgroundColor:'rgb(155, 155, 155)',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    }} 
  >
    Nächste
  </button>
</div>

    </div>
  );
};

export default CreditNoteList;
